module.exports = __webpack_public_path__ + "img/content-with-img-links-chevy.f34eb63e.jpg";